import {AxiosInstance} from 'axios'
import _Vue from 'vue'
import BanzaiHistoryService from '@/services/banzai-history.service'

export default {
  install(
    Vue: typeof _Vue,
    {http}: { http: AxiosInstance }) {
    Vue.prototype.$banzaiHistory = new BanzaiHistoryService(http)
  },
}

declare module 'vue/types/vue' {
  interface Vue {
    $banzaiHistory: BanzaiHistoryService;
  }
}
